"use client";
import { useQuery } from "@tanstack/react-query";
import { publicSettingsQuery } from "./art-catalogue-enabled";

/** `bundlesEnabled` from GET /setting/public. FALSE while loading or on error. */
export function useBundlesEnabled(): boolean {
  const { data } = useQuery(publicSettingsQuery);
  return data?.bundlesEnabled === true;
}
